<template>
  <div class="flex flex-col">
    <div class="flex justify-between w-full items-center mx-auto">
      <div class="flex items-center">
        <div class="cursor-pointer flex" @click="$router.push('/')">
        <a href="/">
          <img src="@/assets/SVG/logo_black.svg"/>
        </a>

        <StubCity :theme="'main-text'" class="hidden mt-2 lg:block"></StubCity>
        </div>


      </div>
      <div class="mr-2 items-center hidden lg:inline-block text-sm z-50 relative">
        <div>
          <nav class="-mx-2 flex items-center justify-between whitespace-no-wrap">
                 <a
              href="https://party.mozgo.com/"
              class="text-main-text mx-2 hover:opacity-75 no-underline opacity-100 font-bold outline-none"
              style="transition: all 0.5s"
            >MozgoParty</a>
                <a href="https://partners.mozgo.com/?utm_source=mozgocom" class="">
            <button
              class="text-main-text mx-2 hover:opacity-75 opacity-100 font-bold outline-none"
              style="transition: all 0.5s"
            >Купить франшизу</button> </a>
            <a
              href="https://corp.mozgo.com?utm_source=mozgo"
              class="text-main-text mx-2 hover:opacity-75 opacity-100 font-bold outline-none no-underline"
              style="transition: all 0.5s"
            >Заказать корпоратив</a>
            <a
              href="https://basemozgo.notion.site/Mozg-d69190a80a684e0c9c0f5dbd7a07847b"
              class="text-main-text mx-2 hover:opacity-75 opacity-100 font-bold outline-none no-underline"
              style="transition: all 0.5s"
              v-if="city == 'Екатеринбург'"
            >Вакансии</a>

            <UserModal @logout="$emit('logout')" @registration_open="$emit('auth')"></UserModal>
          </nav>
        </div>
      </div>

      <div class="flex justify-end flex-col relative lg:hidden">
        <img class="lg:hidden w-8 h-8 ml-auto mr-0"
             src="@/assets/SVG/burger-dark.svg" alt=""
             @click.prevent="desktop_menu = $event.target"/>
      </div>

    </div>
    <div class="flex pt-20 items-center relative" >

      <StubCity :theme="'main-text'" class="absolute lg:hidden" style="z-index: 30;top: 2rem;"></StubCity>


      <div class="lg:flex flex-row xl:flex justify-between md:w-7/10 lg:w-3/5 hidden lg:inline-block">
      <div class="flex flex-row pr-20">
        <router-link to="/players/user-data" class="outline-none mr-8 no-underline font-bold text-md xl:text-lg text-main-text whitespace-no-wrap">
          Персональные данные
        </router-link>
      </div>
      <div class="flex flex-row pr-20">
        <router-link to="/players/my-teams" class="outline-none mr-8 no-underline font-bold text-md xl:text-lg text-main-text whitespace-no-wrap">
          Мои команды
        </router-link>
      </div>
      <div class="flex flex-row">
        <router-link to="/players/my-games" class="outline-none mr-8 no-underline font-bold text-md xl:text-lg text-main-text whitespace-no-wrap">
          Мои игры
        </router-link>
      </div>

    </div>
      <a
      style="bottom:14px"
        :href="mpUrl"
        class="toParty flex lg:relative ml-auto no-underline font-bold text-xs text-main-text absolute pin-r">
        <img src="../assets/SVG/cabinet.svg" alt="">
        <p class="ml-3" >Личный кабинет<br>MozgoParty</p>
      </a>
    </div>
    <user-nav-mobile :options="options" class=" z-20 lg:hidden"></user-nav-mobile>
    <desktop-menu v-if="desktop_menu" @close="desktop_menu = false" @logout="$emit('logout')" @registration_open="$emit('auth')" class="lg:hidden"></desktop-menu>

  </div>
</template>

<script>
import UserModal from './user-modal';
import DesktopMenu from '../views/home-page-layouts/components/desktop-menu';
import StubCity from '../views/stub/stub_city';
import UserNavMobile from '../views/players/user-nav-mobile';

export default {
  name: 'moz-header',
  components: {
    UserNavMobile,
    StubCity,
    DesktopMenu,
    UserModal,
  },
  data() {
    return {
      desktop_menu: false,
      options: {
        0: { name: 'Персональные данные', link: '/players/user-data', type: 'user-data' },
        1: { name: 'Мои команды', link: '/players/my-teams', type: 'my-teams' },
        2: { name: 'Мои игры', link: '/players/my-games', type: 'my-games' },
      },
    };
  },
  computed: {
    hideMenu() {
      return this.$route.params.memberId || this.$route.params.teamId;
    },
    mpUrl() {
      return `${process.env.VUE_APP_MP_FRONT}/personal_area/my-data`;
    },
  },
};
</script>

<style lang="less" scoped>
  .toParty {

    border-radius: 5px;
    padding: 20px 10px 0 10px;
  }
  .router-link-active {
  @apply .border-b-2 .border-yellow;
  }
  .toParty {
    border-radius: 5px;
    padding: 20px 10px 0 10px;
  }

  @media only screen and (max-width: 760px) {
    .toParty {
      background-color :rgba(218, 218, 218, 0.2);
    }
    .container {
      max-width: 95%;
    }
  }

  @media only screen and (min-width: 768px) and (max-width: 1270px) {
    .container {
      max-width: 80%;
    }
  }

  @media only screen and (min-width: 1280px) {
    .container {
      max-width: 80%;
    }
  }

</style>
